import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2751f2db"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "autofocus", "type"]
const _hoisted_2 = {
  key: 0,
  class: "tp-icon-loading"
}
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tp-button", [
      $props.type ? 'tp-button--' + $props.type : '',
      _ctx.buttonSize ? 'tp-button--' + _ctx.buttonSize : '',
      {
        'is-disabled': $props.disabled,
        'is-loading': $props.loading,
        'is-plain': $props.plain,
        'is-round': $props.round,
        'is-circle': $props.circle,
      },
    ]]),
    disabled: $props.disabled,
    autofocus: $props.autofocus,
    type: $props.nativeType
  }, [
    ($props.loading)
      ? (_openBlock(), _createElementBlock("i", _hoisted_2))
      : _createCommentVNode("", true),
    ($props.icon && !$props.loading)
      ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: _normalizeClass($props.icon)
        }, null, 2))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}